module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/sanacorp/node_modules/core-js/internals/is-object.js
// module id = 9
// module chunks = 0